import { useTranslation } from 'react-i18next';

import type { ProductSummaryStatus, StoreProductStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';

import { storeProductLiveState } from '../schemas/live-state';

import { StoreLiveChip } from './store-live-chip';

export interface ProductStoreStateChipProps {
  row: { status: StoreProductStatus; publishAt: string | null } | null | undefined;
  masterStatus: ProductSummaryStatus;
}

/** The product in one store, from the master page: what shoppers get there, or "Not added". */
export function ProductStoreStateChip({ row, masterStatus }: ProductStoreStateChipProps) {
  const { t } = useTranslation('storeCatalog');
  return row ? (
    <StoreLiveChip state={storeProductLiveState({ ...row, masterStatus })} className="shrink-0" />
  ) : (
    <Badge variant="outline" className="border-border text-muted-foreground shrink-0">
      {t('productStores.notAdded')}
    </Badge>
  );
}
